export const ClaimsTabRoute = {
  path: '/ClaimsTab',
  load: () => import('./ClaimsTab'),
  protected: true,
};
